import {ValueProvider} from "@angular/core"
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material"
import {MatFormFieldDefaultOptions} from "@angular/material/typings/esm5/form-field"

const options: MatFormFieldDefaultOptions = {
    appearance: "standard"
}

export const FormFieldDefaults: ValueProvider = {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: options
}
